export type SkuRequestMessages = {
  // Success Messages
  deleteSkuSuccess: string;
  activateSkuSuccess: string;
  skuCreateSuccess: string;
  skuUpdateSuccess: string;

  activateSkuError: string;
  skuNotFoundError: string;
  skuCreateError: string;
  skuUpdateError: string;
  skuNotFoundAlt: string;
  skuErrorToLoad: string;
  skuNotFoundDescription: string;
};

export const SKU_REQUEST_MESSAGES: SkuRequestMessages = {
  // Success Messages
  deleteSkuSuccess: "SKU deletado com sucesso.",
  activateSkuSuccess: "Status do SKU alterado com sucesso.",
  skuCreateSuccess: "SKU criado com sucesso.",
  skuUpdateSuccess: "SKU atualizado com sucesso.",

  // Error Messages
  activateSkuError: "Erro ao alterar status do SKU.",
  skuNotFoundError: "SKU não encontrado.",
  skuCreateError: "Erro ao criar o SKU.",
  skuUpdateError: "Erro ao atualizar o SKU.",
  skuNotFoundAlt: "SKU não encontrado.",
  skuErrorToLoad: "Erro ao carregar o SKU.",
  skuNotFoundDescription: "Não conseguimos encontrar o SKU que você está procurando",
};
